import { Paragraph } from "docx";

/**
 * Splits plain text on newlines so each line can become its own Word paragraph.
 * `\r\n` and `\n` are treated the same. Empty input yields a single empty line.
 * @param {string} [text]
 * @returns {string[]}
 */
export function splitMultilineText(text) {
    if (text == null || text === "") {
        return [""];
    }
    return String(text).split(/\r?\n/);
}

/**
 * Converts a notes/plain-text string into one Word Paragraph per line.
 * Empty lines become empty paragraphs so blank lines in Notes are preserved.
 * @param {string} [text]
 * @returns {Paragraph[]}
 */
export function paragraphsFromMultilineText(text) {
    return splitMultilineText(text).map((line) => new Paragraph(line));
}
